import React from 'react';


const ECheck = ({name, number}: {name: string, number: number}) => {
  return (
    <div className="echeck">
      <div className="echeck__card">
        <div className="echeck__issuer" />
        <div className="echeck__number">{number}</div>
        <div className="echeck__name ">{name}</div>
      </div>
    </div>
  );
};

export default ECheck;
